<app-dashboard>
  <div class="w-full flex flex-col p-[20px] gap-[30px]">
    <div *ngIf="canWrite" class="w-full flex justify-end">
      <app-button
        [label]="'Create Vault'"
        (onClick)="openCreateModal()"
        [className]="
          'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center rounded-[5px] bg-[#081A46] cursor-pointer'
        "
      ></app-button>
    </div>
    <div *ngIf="!canWrite" class="w-full h-[30px]"></div>
    <div class="w-full">
        <div *ngIf="fetchingData" class="w-full flex flex-col gap-[10px]">
            <div class="bg-slate-100 w-full rounded-[10px] h-[70px] animate-pulse"></div>
            <div class="bg-slate-100 w-full rounded-[10px] h-[70px] animate-pulse"></div>
          </div>
          <div *ngIf="emptyState && vaults.length === 0" class="w-full flex justify-center items-center">
            <div class="w-fit flex flex-col gap-[5px] items-center">
              <img src="../../../assets/images/empty.svg" alt="">
              <span class="text-center text-[16px] font-[800] text-[#364152]">No Data Found</span>
              <span class="text-center text-[14px] font-[400] text-[#6B7280]">Create a new Vault</span>
            </div>
          </div>
          <div class="flex flex-col w-full gap-[15px]">
        <ng-container *ngFor="let vault of vaults; index as i" >
            <div  *ngIf="!fetchingData" class="webhook-card">
              <div class="name-section">
                <span class="name">{{vault?.name}}</span>
                <span class="type">Created At: {{formatDate(vault?.createdAt)}}</span>
              </div>
              <div class="middle">
               <div class="flex flex-col">
                <span class="text-slate-600 font-[600] text-[12px]">Environment:</span>
                <span class="title capitalize"
                >{{vault?.environment}}</span
              >
               </div>
            </div>
                <div class="flex flex-col">
                    <span class="text-slate-600 font-[600] text-[12px]">Key:</span>
                    <div class="flex gap-[5px] items-center">
                        <span class="title"> {{ showKey[i] ? vault?.vaultKey : '********' }}</span>
                        <img (click)="toggleVisibility(i)" class="cursor-pointer" src="../../../assets/icons/{{!showKey[i] ? 'Eye.svg' : 'eye-hidden.svg'}}" alt="">
                    </div>
                </div>
              <div class="end">
                <div *ngIf="canDelete" (click)="openDeleteModal(vault?._id)" class="icon-delete"></div>
              </div>
            </div>
          </ng-container>
        </div>
        <app-pagination
        *ngIf="!fetchingData && this.totalVaults > 0"
        [totalItems]="this.totalVaults"
        [(pageSize)]="this.limit"
        [(currentPage)]="this.page"
        (pageSizeChange)="this.refreshList()"
        (currentPageChange)="this.getVaults()"
      ></app-pagination>
        <!-- <app-table
        [tableData]="tableData"
        [tableHeader]="tableHeader"
        (rowClick)="manageRoute($event)"
        [tableTitle]="'Transactions'"
        [loading]="fetchingData"
        [emptyState]="emptyTableState"
        [filterData]="filterData"
        (handleFilter)="applyFilter($event)"
        (handleSearch)="search($event)"
        [tableWidth]="' min-w-[990px]'"
        [toolbar]="{
          paginate: true,
          search: true,
          filter: true,
          addnew: false
        }"
        [paginationData]="{
          limit: limit,
          totalData: totalVaults
        }"
        (changeLimit)="changeLimit($event)"
      >
        <div class="flex justify-end items-center sm:w-full">
          <app-pagination
            *ngIf="!fetchingData && this.totalVaults > 0"
            [totalItems]="this.totalVaults"
            [(pageSize)]="this.limit"
            [(currentPage)]="this.page"
            (pageSizeChange)="this.refreshList()"
            (currentPageChange)="this.getVaults()"
          ></app-pagination>
        </div>
      </app-table> -->
    </div>
  </div>
</app-dashboard>
<app-modal
  [title]="'Create New Vault'"
  [isOpen]="createModalOpen"
  (closeModalEvent)="closeCreateModal()"
>
  <div class="w-full flex flex-col">
    <app-input (returnValue)="handleInput($event)" [title]="'name'" [error]="errors.name" [label]="'Name'" [placeholder]="'Enter vault name..'" />
    <app-dropdown [label]="'Environment'" [placeholder]="'eg.. Development'" [title]="'environment'" [error]="errors.environment" (selectedValue)="handleInput($event)" [items]="vaultEnvironments" />
    <app-button
      [label]="'Create Vault'"
      [loading]="loading"
      (onClick)="createVault()"
      [className]="
        'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'"
    ></app-button>
  </div>

</app-modal>
<app-modal
  [title]="'Delete Vault'"
  [isOpen]="deleteModalOpen"
  (closeModalEvent)="closeDeleteModal()"
>
  <div class="flex flex-col w-full gap-[30px] items-center">
    <span class="text-slate-800 text-[14px]">Delete this Vault?</span>
    <div class="w-full flex justify-end">
      <!-- <app-button
        [label]="'Close Modal'"
        (onClick)="closeDeleteModal()"
        [className]="
          'text-[#081A46] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] border border-[#081A46]'
        "
      ></app-button> -->
      <app-button
        [label]="'Delete Vault'"
        (onClick)="deleteVault()"
        [loading]="loading"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
  </div>
</app-modal>